// removed by extract-text-webpack-plugin
module.exports = {"block":"_3Fuclxytg6VzMM1IP_5uxO","yellow":"_1hgUj30y04AEQV4mBbhMqH","lightgray":"_1YGJRJXqXj9E7EFexmSnJ3","text":"_1rsGoXAxDwYr0wODsa9kXH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TopText/TopText.module.scss
// module id = 811
// module chunks = 0